module.exports = __webpack_public_path__ + "static/media/vector.04229e31.svg";